import queryString from 'query-string';
import Config from './Config';

export const continueWithFacebookUrl = () => {
  const { protocol } = window.location;
  const {
    oauth: { domain, redirectSignIn, responseType, scope },
    userPoolWebClientId,
  } = Config.get().Auth;

  const queryParams = queryString.stringify({
    identity_provider: 'Facebook',
    redirect_uri: redirectSignIn,
    response_type: responseType,
    client_id: userPoolWebClientId,
    scope: scope.join(' '),
  });

  return `${protocol}//${domain}/oauth2/authorize?${queryParams}#`;
};
